import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { loginUser } from "../store/actions/authActions";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import {
  TextField,
  Button,
  Typography,
  Box,
  Alert,
  CircularProgress,
  Paper,
} from "@mui/material";
import { useTranslation } from "react-i18next";

const LoginSchema = Yup.object().shape({
  email: Yup.string().email("Invalid email").required("Required"),
  password: Yup.string().required("Required"),
});

const LoginComponent = () => {
  const dispatch = useDispatch();
  const { loading, error } = useSelector((state) => state.auth);
  const { t } = useTranslation(); // Get the t function

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "radial-gradient(circle at top left, #fef08a 0%, #93c5fd 100%)",
        backgroundAttachment: "fixed",
      }}
    >
      <Paper
        elevation={6}
        sx={{
          padding: 4,
          maxWidth: 400,
          width: "100%",
          borderRadius: 3,
          backgroundColor: "rgba(255, 255, 255, 0.3)",
          // background: "url(./assets/logo.png)",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "top",
          backgroundSize: "40%",
        }}
      >
        <Typography
          variant="h4"
          align="center"
          gutterBottom
          color="primary"
          marginTop="1em"
        >
          {t("common.welcome")}
        </Typography>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        <Formik
          initialValues={{ email: "john.doe@foxpost.hu", password: "test123" }} // TODO: remove initial values
          validationSchema={LoginSchema}
          onSubmit={(values) => {
            dispatch(loginUser(values));
          }}
        >
          {({ handleChange, handleBlur, values }) => (
            <Form>
              <TextField
                fullWidth
                margin="normal"
                label={t("login.email")}
                name="email"
                type="email"
                color="primary"
                value={values.email}
                onChange={handleChange}
                onBlur={handleBlur}
                helperText={<ErrorMessage name="email" />}
                // error={Boolean(<ErrorMessage name="email" />)}
              />
              <TextField
                fullWidth
                margin="normal"
                label={t("login.password")}
                name="password"
                type="password"
                color="secondary"
                value={values.password}
                onChange={handleChange}
                onBlur={handleBlur}
                helperText={<ErrorMessage name="password" />}
                // error={Boolean(<ErrorMessage name="password" />)}
              />
              <Box mt={3}>
                <Button
                  type="submit"
                  variant="outlined"
                  color="primary"
                  fullWidth
                  disabled={loading}
                >
                  {loading ? <CircularProgress size={24} /> : t("login.submit")}
                </Button>
              </Box>
              <Typography variant="body2" align="center" sx={{ mt: 2 }}>
                <i>{t("login.noAccountInfo")}</i>
              </Typography>
            </Form>
          )}
        </Formik>
      </Paper>
    </Box>
  );
};

export default LoginComponent;
